var map = {
	"./": 2340,
	"./demo.md": 3709,
	"./ecmascript/banner.webp": 9152,
	"./ecmascript/ecmascript.md": 1600,
	"./index": 2340,
	"./index.js": 2340,
	"./miPrimer/banner.webp": 8532,
	"./miPrimer/miPrimer.md": 8787,
	"./npm/banner.webp": 405,
	"./npm/npm.md": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3892;